import { Head, Link } from "@inertiajs/react"
import { ChevronRight, User } from "lucide-react"
import { AdminShell } from "@/components/AdminShell"
import { Button } from "@/components/ui/button"

type PersonRow = {
  id: number
  name: string
  slug: string
  members_count: number
  recordings_count: number
  created_at: string
}

export default function AdminPeopleIndex({ people }: { people: PersonRow[] }) {
  return (
    <>
      <Head title="People">
        <meta name="description" content="Manage people in the admin area." />
        <meta property="og:title" content="People" />
        <meta property="og:description" content="Manage people in the admin area." />
      </Head>
      <AdminShell>
        <div className="border-b border-hairline pb-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
            <div>
              <h1>People</h1>
              <p className="mt-1">
                {people.length} {people.length === 1 ? "person" : "people"} in the database.
              </p>
            </div>
            <Button asChild>
              <Link href="/admin/people/new">New person</Link>
            </Button>
          </div>
        </div>

        <ul className="mt-6 divide-y divide-hairline overflow-hidden rounded-md border border-hairline bg-page">
          {people.map((person) => (
            <li key={person.id}>
              <Link
                href={`/admin/people/${person.slug}`}
                className="flex items-center gap-3 px-4 py-3 no-underline hover:bg-surface"
              >
                <User className="h-4 w-4 shrink-0 text-ink-muted" />
                <div className="min-w-0 flex-1">
                  <div className="truncate text-sm font-medium text-ink-display">{person.name}</div>
                  <div className="truncate text-xs text-ink-muted">
                    {person.members_count} bands · {person.recordings_count} recordings
                  </div>
                </div>
                <ChevronRight className="h-4 w-4 shrink-0 text-ink-muted" />
              </Link>
            </li>
          ))}
        </ul>
      </AdminShell>
    </>
  )
}
